const configOptions = () => ({
  Allgemein: {
    settings: [
      {
        label: 's+ ATHESIA Netzwerk Freischaltung deaktivieren',
        valueKey: 'dlabSPlusAuth',
      },
      {
        label: 'Test Banner',
        valueKey: 'dlabAdsTest',
      },
    ],
    expanded: true,
  },
  'Console Logs': {
    settings: [
      {
        label: 'src/vendor/Piano/components/ExperiencePiano',
        valueKey: 'dlabExperiencePianoTest',
      },
      {
        label: 'src/bundles/BundleSPNWidgets/components/Content',
        valueKey: 'dlabSPNContentTest',
      },
      {
        label: 'src/components/BookmarkSymbol',
        valueKey: 'dlabBookmarkSymbolTest',
      },
      {
        label: 'src/topics/Bookmark',
        valueKey: 'dlabBookmarkTest',
      },
      {
        label: 'src/layouts/Default/components/AutomaticLogin',
        valueKey: 'dlabAutomaticLoginTest',
      },
      {
        label: 'src/layouts/Default',
        valueKey: 'dlabDefaultLayoutTest',
      },
      {
        label: 'src/modules/fetch-data',
        valueKey: 'dlabFetchDataTest',
      },
      {
        label: 'src/modules/ads-targets',
        valueKey: 'dlabAdsTargetsTest',
      },
      {
        label: 'src/modules/use-access',
        valueKey: 'dlabUseAccessTest',
      },
      {
        label: 'src/vendor/Piano/components/InitializePiano/modules/on-checkout-complete',
        valueKey: 'dlabOnCheckoutCompleteTest',
      },
      {
        label: 'src/vendor/Piano/components/InitializePiano/modules/on-login-success',
        valueKey: 'dlabOnLoginSuccessTest',
      },
      {
        label: 'src/vendor/Piano/modules/login-piano',
        valueKey: 'dlabPianoLoginByTokenTest',
      },
      {
        label: 'src/vendor/Piano/modules/use-user-data',
        valueKey: 'dlabUserDataTest',
      },
      {
        label: 'src/vendor/Sourcepoint/modules/use-consent-ready',
        valueKey: 'dlabSourcePointTest',
      },
      {
        label: 'src/vendor/AdThirdParty/components/Criteo',
        valueKey: 'dlabAdsCriteoTest',
      },
    ],
  },
})

export default configOptions
